import { useState } from "react";

export const useFilter = (initialFilters = {}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleFilterApply = (cb) => (filters) => {
    setFilters(() => filters);
    cb?.(filters)
  };

  const handleFilterReset = (cb) => () => {
    setFilters({});
    cb?.();
  };

  return {
    filters,
    isFilterOpen,
    setIsFilterOpen,
    handleFilterApply,
    handleFilterReset,
  };
};
